import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  FormControl,
  Grid,
  InputLabel,
  Select,
  TextField,
  Button,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import { Autocomplete, Chip } from "@mui/material";
import SaveIcon from "@material-ui/icons/Save";
import {
  GET_ALL_ENTERPRISE,
  GET_ALL_SEDE,
  GET_ALL_PROJECT,
  GET_ALL_PUESTOS,
  UPDATE_USERS,
  GET_USERS_BY_ID,
  GET_ALL_USERS_NUEVOINGRESO,
} from "../../../../Querys/querys";
import { GET_ALL_PAQUETES } from "../../../../Querys/prestaciones/querys";
import { useQuery, useMutation } from "@apollo/client";
import moment from "moment";
import { IProject } from "../../../../interfaces/Project";
import { SuccessfulAlert } from "../../../../alerts/successAlerts";
import CollaboratorContext from "../../../../context/CollaboratorContext/CollaboratorContext";

const InputDataInactivos = () => {
  const { state } = useContext(CollaboratorContext);
  const location = useLocation();
  const isEditable = location.pathname.startsWith("/inactivos");
  const [projects, setProjects] = useState<Array<IProject>>([]);
  const [puestos, setPuestos] = useState<Array<any>>([]);
  const [campus, setCampus]: any = useState(null);

  const { data: resultProject } = useQuery(GET_ALL_PROJECT);
  const allProject = resultProject?.GET_ALL_PROJECT;

  const { data: resultPuestos } = useQuery(GET_ALL_PUESTOS);
  const allPuestos = resultPuestos?.GET_ALL_PUESTOS;

  const { data: dataSedes } = useQuery(GET_ALL_SEDE, {
    fetchPolicy: "no-cache",
  });
  const allCampus = dataSedes?.GET_ALL_SEDE;

  const { data: dataPaquetes } = useQuery(GET_ALL_PAQUETES, {
    fetchPolicy: "no-cache",
  });
  const allPaquetes: any[] = dataPaquetes?.GET_ALL_PAQUETES ?? [];

  const [paquetesSugeridos, setPaquetesSugeridos] = useState<any[]>([]);
  const [idPaqueteSeleccionado, setIdPaqueteSeleccionado] = useState<string | null>(
    state.collaborator?.idPaquete ? String(state.collaborator.idPaquete) : null
  );

  const [updateColaboradores] = useMutation(UPDATE_USERS, {
    refetchQueries: [
      { query: GET_USERS_BY_ID, variables: { getUsersId: state.collaborator?.id } },
      { query: GET_ALL_USERS_NUEVOINGRESO },
    ],
  });

  const [puesto, setPuesto] = useState("");
  const [project, setProject] = useState("");
  const [sede, setSede] = useState("");

  useEffect(() => {
    if (allProject) {
      for (const item of allProject) {
        if (
          state &&
          state.collaborator &&
          Number(state.collaborator.idProject) === Number(item.id)
        ) {
          setProject(item.proyectNameAndClient);
        }
      }
      setProjects(allProject);
    }
  }, [allProject, state]);

  useEffect(() => {
    if (allPuestos) {
      for (const item of allPuestos) {
        if (
          state &&
          state.collaborator &&
          Number(state.collaborator.puestoId) === Number(item.idPuesto)
        ) {
          setPuesto(item.NombrePuesto);
        }
      }
      setPuestos(allPuestos);
    }
  }, [allPuestos, state]);

  useEffect(() => {
    if (allCampus) {
      setSede(state.collaborator.campus);
      setCampus(allCampus);
    }
  }, [allCampus, state]);

  useEffect(() => {
    if (allPaquetes.length > 0 && state.collaborator?.idProject) {
      const sugeridos = allPaquetes.filter(
        (p: any) =>
          String(p.idProject) === String(state.collaborator.idProject) &&
          p.status === true
      );
      setPaquetesSugeridos(sugeridos);
    }
  }, [allPaquetes, state.collaborator?.idProject]);

  const handleGuardarPaquete = () => {
    updateColaboradores({
      variables: {
        updateUsersId: state.collaborator?.id,
        input: { idPaquete: idPaqueteSeleccionado },
        process: { tab: "information", section: "section_2" },
      },
    }).then(() => {
      SuccessfulAlert({ text: "Paquete de prestaciones asignado correctamente" });
    });
  };

  return (
    <>
      <div
        className={
          state.sections[1] >= 100 ? `validate__border` : `novalidate__border`
        }
      >
        <Grid
          direction="row"
          container
          justify="flex-start"
          alignItems="center"
        >
          <Grid xs item>
            <span className="Fecha-de-nacimiento">Fecha de ingreso</span>
          </Grid>
          <Grid xs item container justify="flex-end" alignItems="center">
            <TextField
              type="date"
              defaultValue={
                state.collaborator
                  ? moment
                      .utc(state.collaborator.dateOfAdmission)
                      .format("YYYY-MM-DD")
                  : ""
              }
              autoFocus={true}
              name="dateOfAdmission"
              variant="outlined"
              size="small"
              InputProps={{
                readOnly: true,
              }}
              disabled={true}
            />
          </Grid>
        </Grid>

        <Box mb={2} mt={2}>
          <FormControl variant="outlined" fullWidth={true} size="small">
            <TextField
              type="text"
              name="officePlace"
              label="Lugar de trabajo"
              defaultValue={state.collaborator?.officePlace}
              variant="outlined"
              size="small"
              fullWidth={true}
              InputProps={{
                readOnly: true,
              }}
              style={{ opacity: 0.5 }}
            />
          </FormControl>
        </Box>

        <Box mb={2} mt={2}>
          <Grid direction="row" container spacing={2}>
            <Grid xs item>
              <FormControl variant="outlined" fullWidth={true} size="small">
                <TextField
                  type="text"
                  name="campus"
                  label="Selecciona sede"
                  value={sede}
                  variant="outlined"
                  size="small"
                  fullWidth={true}
                  InputProps={{
                    readOnly: true,
                  }}
                  style={{ opacity: 0.5 }}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        <Grid direction="row" container spacing={2}>
          <Grid xs item>
            <FormControl variant="outlined" fullWidth={true} size="small">
              <TextField
                type="text"
                name="idProject"
                label="Selecciona área o proyecto"
                value={project}
                variant="outlined"
                size="small"
                fullWidth={true}
                InputProps={{
                  readOnly: true,
                }}
                style={{ opacity: 0.5 }}
              />
            </FormControl>
          </Grid>
          <Grid xs item>
            <FormControl variant="outlined" fullWidth={true} size="small">
              <TextField
                type="text"
                name="puestoId"
                label="Puesto"
                value={puesto}
                variant="outlined"
                size="small"
                fullWidth={true}
                InputProps={{
                  readOnly: true,
                }}
                style={{ opacity: 0.5 }}
              />
            </FormControl>
          </Grid>
        </Grid>

        {(() => {
          const paqueteAsignado = allPaquetes.find((p: any) => String(p.id) === String(idPaqueteSeleccionado ?? state.collaborator?.idPaquete));
          if (!isEditable) {
            return paqueteAsignado ? (
              <Box mb={2} mt={2}>
                <FormControl variant="outlined" fullWidth={true} size="small">
                  <TextField
                    type="text"
                    label="Paquete de prestaciones"
                    value={paqueteAsignado.nombre}
                    variant="outlined"
                    size="small"
                    fullWidth={true}
                    InputProps={{ readOnly: true }}
                    style={{ opacity: 0.5 }}
                  />
                </FormControl>
              </Box>
            ) : null;
          }
          return allPaquetes.filter((p: any) => p.status).length > 0 ? (
            <Box mb={2} mt={2}>
              <FormControl variant="outlined" fullWidth={true} size="small">
                <Autocomplete
                  disablePortal
                  id="idPaquete"
                  options={[
                    ...allPaquetes.filter((p: any) => p.status && paquetesSugeridos.some((s: any) => String(s.id) === String(p.id))).map((p: any) => ({ label: p.nombre, id: String(p.id), sugerido: true })),
                    ...allPaquetes.filter((p: any) => p.status && !paquetesSugeridos.some((s: any) => String(s.id) === String(p.id))).map((p: any) => ({ label: p.nombre, id: String(p.id), sugerido: false })),
                  ]}
                  groupBy={(option: any) => option.sugerido ? "Sugeridos para este proyecto" : "Otros paquetes"}
                  value={
                    paqueteAsignado
                      ? { label: paqueteAsignado.nombre, id: String(paqueteAsignado.id), sugerido: false }
                      : null
                  }
                  onChange={(_e, value) => {
                    setIdPaqueteSeleccionado(value?.id ?? null);
                  }}
                  renderOption={(props, option: any) => (
                    <li {...props}>
                      <span style={{ flexGrow: 1 }}>{option.label}</span>
                      {option.sugerido && (
                        <Chip label="Sugerido" size="small" style={{ backgroundColor: "#fabb00", color: "#000", marginLeft: 8, fontWeight: 600 }} />
                      )}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="idPaquete"
                      variant="outlined"
                      size="small"
                      label="Paquete de prestaciones"
                    />
                  )}
                />
              </FormControl>
              <Grid direction="row" container justify="flex-end" style={{ marginTop: "12px" }}>
                <Button
                  className="buttonSave"
                  onClick={handleGuardarPaquete}
                  disabled={!idPaqueteSeleccionado}
                >
                  <SaveIcon />
                  &nbsp; Guardar
                </Button>
              </Grid>
            </Box>
          ) : null;
        })()}
      </div>
    </>
  );
};

export default InputDataInactivos;
